import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { PieChartTwoPaths } from '../../../../../common/chart/pieChart/pieChartTwoPaths'
import { Element } from '../../../../../common/html/element'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { Tabs } from '../../../../../common/tabs'
import { getAppendStyleItemWithCustom } from '../../../../../common/tabs/helper'
import { keyBy } from '../../../../../helpers/common'
import { formatVal } from '../../../../../helpers/value'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  getYearTabs,
  handleIconDownload,
} from '../../helper'
import classes from '../../index.module.scss'
import { changeYear, selectYear } from '../../store/slice'
import { EACH_YEAR_NET, EACH_YEAR_RATIO } from './constant'
import {
  selectDataViewByEachYear,
  selectIndicatorById,
  selectYears,
} from './store/slice'

const EachYear = ({ id, isDynamicReport, year: yearSetting }) => {
  const dispatch = useDispatch()
  const locale = useSelector((state) => state.i18n.locale)
  const year = useSelector(selectYear(id, yearSetting))
  const data = useSelector(selectDataViewByEachYear(year))
  const dataById = keyBy(data, 'id')
  const indicatorById = useSelector(selectIndicatorById)
  const { formatCurrencyWithUnit } = useFormatCurrency(
    SCREEN.FINANCIAL_ANALYSIS,
  )
  const years = useSelector(selectYears)

  const tabs = getYearTabs(years)

  const setYear = (year) => dispatch(changeYear({ id, year }))

  useEffect(() => {
    if (
      (tabs.length && !year) ||
      !tabs.map((item) => item.key).includes(String(year))
    ) {
      setYear(tabs[tabs.length - 1]?.key)
    }
  }, [tabs.length, year])

  const ratios = EACH_YEAR_RATIO.map((item) => ({
    ...item,
    ratioName: indicatorById[item.id]?.ratioName,
    ratioValue: dataById[item.id]?.value,
    industryValue: dataById[item.industryId]?.value,
  }))

  const nets = EACH_YEAR_NET.map((item) => ({
    ...item,
    ratioName: indicatorById[item.id]?.ratioName,
    ratioValue: dataById[item.id]?.value,
  }))

  const isNoData = !data?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (!year) return getNoDataComponent(isDynamicReport)

  return (
    <div
      style={{
        height: getStyleHeightContainer(isDynamicReport, isNoData, 332),
      }}
      className={`flexColumn ${classes.liquidityEachYearContainer}`}
    >
      <Element
        style={{
          borderBottom: !isDynamicReport ? '1px solid #B5CEF8' : undefined,
        }}
        className={`dFlex justifyContentEnd ${classes.tabContainer}`}
      >
        {!isDynamicReport ? (
          <Tabs
            activeKey={year}
            items={tabs}
            tabListClassName={classes.tabs}
            getAppendStyleItem={getAppendStyleItemWithCustom()}
            isScrollContent={false}
            onChange={setYear}
          />
        ) : (
          <>
            {!isNoData && (
              <div className="fw600 py1 w100">
                <Translate value="common.FISCAL_YEAR" />: {year}
              </div>
            )}
          </>
        )}
      </Element>
      {isNoData ? (
        getNoDataComponent(isDynamicReport)
      ) : (
        <div className="h100">
          <div className="flexColumn h100">
            <div className="h100 dFlex">
              {ratios.map((item, index) => (
                <div key={index} className={classes.chartContainer}>
                  <div className="h100 w100 dFlex alignItemsCenter justifyContentCenter">
                    <PieChartTwoPaths
                      width={150}
                      height={150}
                      pieChartRatio={1}
                      pathSmallRatio={0.75}
                      topPathText={
                        <Element
                          style={{
                            color: '#191D25',
                            padding: '16px 16px 0px 16px',
                          }}
                        >
                          <Element className="fw500" style={{ fontSize: 14 }}>
                            {item.ratioName}
                          </Element>
                          <Element className="fw600" style={{ fontSize: 24 }}>
                            {formatVal(item.ratioValue, locale)}
                          </Element>
                        </Element>
                      }
                      bottomPathText={
                        <div className="fw600">
                          <div>
                            <Translate value="financialAnalysis.INDUSTRY_AVG" />
                          </div>
                          <div>{formatVal(item.industryValue, locale)}</div>
                        </div>
                      }
                      topPathFill={item.topColor}
                      topPathStroke={item.topColor}
                      backgroundPathFill={item.topColor}
                      backgroundPathStroke={item.topColor}
                      bottomPathStroke={item.bottomColor}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className="dFlex justifyContentBetween">
              {nets.map((item, index) => (
                <Element
                  key={index}
                  style={{ background: '#EDF5FE' }}
                  className={classes.infoContainer}
                >
                  <div>
                    <div className="fw600">{item.ratioName}</div>
                    <Element style={{ fontSize: 14 }} className="fw600">
                      {formatCurrencyWithUnit({ value: item.ratioValue })}
                    </Element>
                  </div>
                </Element>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default EachYear
